import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/ui-kit/button';
import { cn } from '@/lib/utils';

export const FinalCta = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 min-h-[500px]">
        <img
          src="/images/mountain-bg-overlayed.jpg"
          alt=""
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 lg:px-8">
        <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8 text-white">
          {/* Oliver image */}
          <div className="shrink-0">
            <img
              src="/images/oliver.png"
              alt="Oliver, your guide to creating legal documents"
              loading="lazy"
              width={350}
              height={350}
              className="w-[280px] h-[280px] md:w-[350px] md:h-[350px] object-cover rounded-md"
            />
          </div>

          {/* Text + CTA */}
          <div className="p-4 space-y-4 text-center md:text-left">
            <h2 className="font-extrabold text-3xl md:text-4xl font-aptos">
              {t('LANDING_FINAL_CTA_TITLE')}
            </h2>
            <p className="text-white/90 font-open-sans leading-relaxed">
              {t('LANDING_FINAL_CTA_SUBTITLE')}
            </p>
            <Link
              to="/templates"
              className={cn(buttonVariants(), 'border-2 border-selise-blue bg-selise-blue hover:bg-selise-blue/80 text-white font-semibold px-8 h-11 text-lg transition-colors mt-2')}
            >
              {t('LANDING_FINAL_CTA_BUTTON')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
